function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
document.addEventListener('DOMContentLoaded', function() {
    // document.querySelectorAll('.faq__item').forEach((item) => {
    //   item.addEventListener('toggle', () => {
    //     if (item.open) {
    //       document.querySelectorAll('.faq__item').forEach((other) => {
    //         if (other !== item) other.removeAttribute('open');
    //       });
    //     }
    //   });
    // });
    var form = document.getElementById('founderForm');
    var successBlock = document.querySelector('.join__content.success');
    var formBlock = document.querySelector('.join__content:not(.success)');
    var submitBtn = form.querySelector('button');
    function showError(input, message) {
        var error = input.parentNode.querySelector('.error-msg');
        if (!error) {
            error = document.createElement('p');
            error.className = 'error-msg';
            error.style.color = '#ff5b5b';
            error.style.fontSize = '14px';
            error.style.marginTop = '4px';
        // input.parentNode.appendChild(error);
        }
        error.textContent = message;
        input.classList.add('input-error');
    }
    function clearErrors() {
        form.querySelectorAll('.error-msg').forEach(function(el) {
            return el.remove();
        });
        form.querySelectorAll('.input-error').forEach(function(el) {
            return el.classList.remove('input-error');
        });
    }
    function validateForm() {
        clearErrors();
        var valid = true;
        var fullName = document.getElementById('full_name');
        var email1 = document.getElementById('email');
        var locationField = document.getElementById('location');
        var social = document.getElementById('social');
        var phone = document.getElementById('phone');
        var message = document.getElementById('message');
        var nda = document.getElementById('nda');
        var ugc = document.getElementById('ugc');
        // Nombre
        if (!fullName.value.trim()) {
            showError(fullName, 'Ingresa tu nombre completo');
            valid = false;
        }
        // Email
        if (!email1.value.trim()) {
            showError(email1, "Ingresa tu correo electr\xf3nico");
            valid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email1.value)) {
            showError(email1, "Ingresa un email v\xe1lido");
            valid = false;
        }
        // Ciudad / País
        if (!locationField.value.trim()) {
            showError(locationField, "Ingresa tu ciudad y pa\xeds");
            valid = false;
        }
        // Instagram o TikTok
        if (!social.value.trim()) {
            showError(social, 'Ingresa tu cuenta de Instagram o TikTok');
            valid = false;
        }
        // Teléfono
        if (!phone.value.trim()) {
            showError(phone, "Ingresa tu n\xfamero de tel\xe9fono");
            valid = false;
        }
        // Mensaje
        if (!message.value.trim()) {
            showError(message, 'Escribe un mensaje');
            valid = false;
        }
        // NDA
        if (!nda.checked) {
            showError(nda, "Debes aceptar los T\xe9rminos y NDA para continuar");
            valid = false;
        }
        // UGC
        if (!ugc.checked) {
            showError(ugc, "Debes aceptar la autorizaci\xf3n de contenido UGC");
            valid = false;
        }
        return valid;
    }
    form.addEventListener('submit', function(e) {
        return /*#__PURE__*/ _async_to_generator(function() {
            var payload, res, responseData, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (!validateForm()) return [
                            2
                        ];
                        submitBtn.disabled = true;
                        submitBtn.textContent = 'Enviando...';
                        payload = {
                            data: {
                                type: 'profile',
                                attributes: {
                                    email: email.value,
                                    phone_number: document.getElementById('phone').value || null,
                                    properties: {
                                        full_name: document.getElementById('full_name').value,
                                        location: document.getElementById('location').value,
                                        social: document.getElementById('social').value,
                                        message: document.getElementById('message').value,
                                        nda_accepted: document.getElementById('nda').checked,
                                        ugc_accepted: document.getElementById('ugc').checked,
                                        form_source: 'Shokko Founder 2025 Landing'
                                    }
                                }
                            }
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fetch('https://submitfounder-yvpeumq7ya-uc.a.run.app', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(payload)
                            })
                        ];
                    case 2:
                        res = _state.sent();
                        return [
                            4,
                            res.json()
                        ];
                    case 3:
                        responseData = _state.sent();
                        if (res.ok) {
                            // Caso perfil duplicado
                            // 1️⃣ Email inválido
                            if (responseData.invalidEmail) {
                                alert("El correo ingresado no es v\xe1lido. Por favor revisalo.");
                                submitBtn.disabled = false;
                                submitBtn.textContent = 'Unirme como Founder';
                                return [
                                    2
                                ];
                            }
                            // 2️⃣ Perfil duplicado
                            if (responseData.duplicate === true) {
                                alert("Parece que este correo ya est\xe1 registrado \uD83D\uDC9C. Gracias por tu inter\xe9s en ser Founder. Muy pronto sabr\xe1s de nosotros.");
                                submitBtn.disabled = false;
                                submitBtn.textContent = 'Unirme como Founder';
                                return [
                                    2
                                ];
                            }
                            // Mostrar bloque de éxito igual
                            formBlock.style.display = 'none';
                            successBlock.style.display = 'flex';
                            successBlock.scrollIntoView({
                                behavior: 'smooth'
                            });
                        } else {
                            console.error(responseData);
                            alert("Hubo un error al enviar tu postulaci\xf3n.");
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.error(error);
                        alert("Error de conexi\xf3n.");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        submitBtn.disabled = false;
                        submitBtn.textContent = 'Unirme como Founder';
                        return [
                            2
                        ];
                }
            });
        })();
    });
    function trackEvent(action, category) {
        var label = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '', value = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : '';
        gtag('event', action, {
            event_category: category,
            event_label: label,
            value: value
        });
    }
    document.querySelectorAll('a[href="#formulario"]').forEach(function(btn) {
        btn.addEventListener('click', function() {
            trackEvent('click_cta_formulario', 'CTA', 'Quiero ser Founder - Hero/Nav');
        });
    });
    document.querySelectorAll('.nav__link').forEach(function(link) {
        link.addEventListener('click', function() {
            trackEvent('click_nav', 'Navigation', link.textContent.trim());
        });
    });
    document.getElementById('founderForm').addEventListener('submit', function() {
        trackEvent('form_submit', 'Formulario Founder', "Postulaci\xf3n enviada");
    });
    document.querySelectorAll('a[href$=".pdf"]').forEach(function(pdf) {
        pdf.addEventListener('click', function() {
            trackEvent('click_pdf', 'Legal Docs', pdf.getAttribute('href'));
        });
    });
    document.querySelectorAll('.footer__socials a').forEach(function(icon) {
        icon.addEventListener('click', function() {
            trackEvent('click_social', 'Social Links', icon.title);
        });
    });
});

//# sourceMappingURL=shokko-founders.1ab127bd.js.map
